module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-2.b080d782.png";